import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RevealDirective } from '../../core/directives/reveal.directive';

interface Promo {
  badge: string;
  badgeClass: string;
  title: string;
  body: string;
  price: string;
}

@Component({
  selector: 'hx-current-promotions',
  standalone: true,
  imports: [MatCardModule, RevealDirective],
  template: `
    <section id="current-promotions" class="section-tight">
      <div class="wrap">
        <div class="section-head reveal" appReveal>
          <p class="eyebrow">Current promotions</p>
          <h2>What's running right now.</h2>
          <p>Offers are updated regularly — check back, or ask your Hexacorp contact what's available for your project.</p>
        </div>

        <div class="promo-cards">
          @for (promo of promos; track promo.title) {
            <div class="reveal" appReveal>
              <mat-card class="card promo-card" appearance="outlined" style="border:none">
                <mat-card-content style="padding:0">
                  <span class="badge" [class.limited]="promo.badgeClass === 'limited'">{{ promo.badge }}</span>
                  <h3>{{ promo.title }}</h3>
                  <p>{{ promo.body }}</p>
                  <div class="price">{{ promo.price }}</div>
                </mat-card-content>
              </mat-card>
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class CurrentPromotionsComponent {
  promos: Promo[] = [
    {
      badge: 'New client',
      badgeClass: '',
      title: 'Free Infrastructure Audit',
      body: 'A full review of your current cloud architecture, cost, and security posture — included free when you start a new project with Hexacorp this quarter.',
      price: 'Value: complimentary with signed SOW',
    },
    {
      badge: 'Limited seats',
      badgeClass: 'limited',
      title: 'Dashboard Build Fast-Track',
      body: 'Book a custom admin dashboard or portal build before the end of the quarter and lock in priority scheduling with a dedicated delivery team.',
      price: 'Ask for current availability',
    },
  ];
}
